<template>
  <div v-loading.fullscreen.lock="isLoading"></div>
</template>
<script>
export default {
  data() {
    return {
      aliApi: require("@/api/ali/mall").default,
      isLoading: false,
    }
  },
  mounted() {
    console.log("route", this.$route);
    if (this.$route.query.code) {
      var code = this.$route.query.code;
      this.onLogin(code);
    } else {
      var search = window.location.search;
      if (search.indexOf("code=") != -1) {
        var code = search.split('=')[1];
        this.onLogin(code);
      } else {
        this.$alert('店铺授权失败，请从应用服务重新访问', '授权失败', {
          confirmButtonText: '确定',
          callback: action => {
            // window.location.href = this.redirectUri;
          }
        });
      }

      // if (process.env.NODE_ENV != "development") {
      //   window.location.href = "https://auth.1688.com/oauth/authorize?client_id=7070333&site=1688&redirect_uri=https://auth.qunxian.net/AliAuth/Order&state=123";
      // }
    }
  },
  methods: {
    onLogin(code) {
      this.isLoading = true;
      this.aliApi.codelogin(code).then(res => {
        this.isLoading = false;
        if (res.errorCode) {
          this.$message.error(res.errorMessage);
        } else {
          // localStorage.setItem("sys_type", res.platform);
          localStorage.setItem("token", res.accessToken);
          localStorage.setItem("user-info", JSON.stringify({
            // logo: res.logoUrl,
            // userName: res.userName,
            mallId: res.mallId,
            mallName: res.mallName,
            refreshToken: res.refreshToken,
            secretKey: res.secretKey,
            // expirationDate: this.$commonJs.toDateString(res.expirationDate)
          }));
          // var mall_list = [];
          // if (res.mallInfos) {
          //   res.mallInfos.forEach(x => {
          //     mall_list.push({ logo: x.logo, mallId: x.mallId, mallName: x.mallName, token: x.accessToken, expirationDate: this.$commonJs.toDateString(x.expirationDate)  })
          //   })
          // }
          // localStorage.setItem("mall_list", JSON.stringify(mall_list));

          this.$router.push("/");
        }
      }).catch(err => {
        this.isLoading = false;
        console.log("err", err);
        // if (process.env.NODE_ENV != "development") {
        //   window.location.href = "https://auth.1688.com/oauth/authorize?client_id=7070333&site=1688&redirect_uri=https://auth.qunxian.net/AliAuth/Order&state=123";
        // }
      })
    }
  }
}

</script>